import { ArrowClockwise, Clock, ShieldWarning, SignOut } from '@phosphor-icons/react';
import { useAuth } from '../lib/auth';
import { Button, Card, cx } from './ui';

/** Shown when a signed-in student is not yet active (pending) or revoked. */
export function AccessGate() {
  const { gate, refresh, logout, user } = useAuth();
  const pending = gate?.state === 'pending';

  return (
    <div className="mx-auto max-w-xl py-10">
      <Card className="p-8 text-center">
        <div
          className={cx(
            'mx-auto flex h-14 w-14 items-center justify-center rounded-2xl',
            pending ? 'bg-amber-50 text-amber-600' : 'bg-rose-50 text-rose-600',
          )}
        >
          {pending ? <Clock size={28} /> : <ShieldWarning size={28} />}
        </div>
        <h1 className="mt-4 text-2xl font-bold">{gate?.title ?? 'Membership pending'}</h1>
        <p className="mt-2 text-slate-600">{gate?.message}</p>
        {user && <p className="label-mono mt-4">Signed in as {user.email}</p>}
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <Button variant="primary" icon={ArrowClockwise} onClick={() => refresh()}>
            Check again
          </Button>
          <Button variant="secondary" icon={SignOut} onClick={() => logout()}>
            Sign out
          </Button>
        </div>
      </Card>
    </div>
  );
}
